import Actions from './action';

export const initState = {
	isContactLoading:false,
	isContactSaveLoading:false,
	contactInfoData:[],
};

const contactInfoReducer = (state = initState, action) => {
	console.log("just")
	switch (action.type) {
		case Actions.types.SAVE_CONTACT_INFO_DATA_START: {
			return {
				...state,
				isContactSaveLoading: true,
			};
		}
		case Actions.types.SAVE_CONTACT_INFO_DATA_SUCCESS: {
			return {
				...state,
				isContactSaveLoading: false,
			};
		}
		case Actions.types.SAVE_CONTACT_INFO_DATA_ERROR: {
			return {
				...state,
				isContactSaveLoading: false,
			};
		}
		case Actions.types.GET_CONTACT_INFO_DATA_START: {
			console.log("helo")
			return {
				...state,
				isContactLoading: true,
			};
		}
		case Actions.types.GET_CONTACT_INFO_DATA_SUCCESS: {
			console.log("SUCCESS",action.res.data)
			return {
				...state,
				isContactLoading: false,
				contactInfoData: action.res.data,
			};
		}
		case Actions.types.GET_CONTACT_INFO_DATA_ERROR: {
			return {
				...state,
				isContactLoading: false,
			};
		}
		default:
			return state;
	}
};


export default contactInfoReducer;
